import BrNotification, { types } from './BrNotification';

BrNotification.Types = types;

export default BrNotification;
